import { sendToDatadog, CAMERA_PRESENTER } from '@shoflo/polymer';

import { TOGGLE_PRESENTER_LIVE } from 'constants/SocketConstants';
import { MAX_CAMERA_LIMIT } from 'constants/index';

import { showNotification } from '../index';

function togglePresenterLive() {
  return (dispatch, getState, socket) => {
    const {
      meeting: { attendeeResponse },
      knock,
      user,
      program
    } = getState();

    const { AttendeeId } = attendeeResponse.Attendee;
    const { broadcastId } = knock;

    const presenterIsLive = program.layers.some(
      layer => layer.source.value === AttendeeId
    );

    const cameraPresenterCount = program.layers.filter(
      layer => layer.source.type === CAMERA_PRESENTER
    );

    if (!presenterIsLive && cameraPresenterCount.length >= MAX_CAMERA_LIMIT) {
      // we will not change the scene since we are on the limit but only display notification to inform the user that the limit is attained.
      dispatch(
        showNotification(
          `You're at the max of ${MAX_CAMERA_LIMIT} sources available at a time in program.`,
          { timeout: 3500, type: 'alert' }
        )
      );
    } else {
      const title = presenterIsLive
        ? `Presenter with id ${user?._id} toggle live state. Previously presenter was live.`
        : `Presenter with id ${user?._id} toggle live state. Previously presenter was not live.`;

      sendToDatadog('presenter-live-toggle', {}, title, false);

      socket.emit(TOGGLE_PRESENTER_LIVE, {
        attendeeId: AttendeeId,
        broadcastId
      });
    }
  };
}

export default togglePresenterLive;
